export default "__VITE_ASSET__01bbc389__"